import React from 'react';
import { HashLink } from 'react-router-hash-link';

const Navbar = () => {
  return (
    <div>
      <div className="collapse navbar-collapse justify-content-center" id="bs-example-navbar-collapse-1">
        <ul className="navbar-nav align-items-center" id="responsive-menu">

          <li className="nav-item">
            <HashLink smooth to="#"  className="nav-link px-7 my-4 py-0">STRONA GŁÓWNA</HashLink>
          </li>

          <li className="nav-item">
            <HashLink smooth to="#offer" scroll={el => {
    const yOffset = -50; // adjust based on your fixed navbar height
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }} className="nav-link px-7 my-4 py-0">OFERTA</HashLink>
          </li>

          <li className="nav-item">
            <HashLink smooth to="#why-us" scroll={el => {
    const yOffset = -80; // adjust based on your fixed navbar height
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }} className="nav-link px-7 my-4 py-0">DLACZEGO MY?</HashLink>
          </li>

          <li className="nav-item">
            <HashLink smooth to="#opinions" scroll={el => {
    const yOffset = -80; // adjust based on your fixed navbar height
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }} className="nav-link px-7 my-4 py-0">OPINIE</HashLink>
          </li>

        </ul>
      </div>
    </div>
  );
};

export default Navbar;
